import { useMemo } from "react"
import { useLocalization } from "@tm/localization"
import { BasketPart } from "@bundles/basket/models"
import { Box, Icon, Stack, Tooltip, Typography } from "@tm/components"

type Props = {
    part: BasketPart
}

export function GraduatedPrices({ part }: Props) {
    const { translateText, formatCurrency } = useLocalization()

    const { graduatedPrices } = part.erpInfoResponse ?? {}
    const title = useMemo(
        () => (
            <Stack gap={0.5}>
                <Typography variant="label">{translateText(705)}</Typography>
                <Box display="grid" gridTemplateColumns="auto auto" columnGap={1}>
                    {graduatedPrices
                        ?.filter((x) => !!x.value)
                        .map(({ currencySymbol, priceUnit, value }) => (
                            <>
                                <Typography textAlign="right">
                                    {translateText(707)} <span className="unit">{priceUnit}</span> {translateText(708)}:
                                </Typography>
                                <Typography textAlign="right" fontWeight={600}>
                                    {formatCurrency(value, currencySymbol)}
                                </Typography>
                            </>
                        ))}
                </Box>
            </Stack>
        ),
        [formatCurrency, graduatedPrices, translateText]
    )

    if (!graduatedPrices) {
        return null
    }

    return (
        <Tooltip title={title} variant="light">
            <Icon name="staffelpreis" />
        </Tooltip>
    )
}
